'use strict';

const SELECTOR = '.js-scroll-prompt';

(function () {
    const element = document.querySelector(SELECTOR);

    if (element === null) {
        return false;
    }

    setTimeout(function(){
        element.classList.remove('is-hidden');
    }, 10000);

    window.onscroll = function() {
        element.classList.add('has-scrolled');
    };

}());
